import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import ContentContainer from "../../common/ContentContainer";
import LockedFeature from "../../MarketIntelligence/LockedFeature";
import { isPremiumOrPro } from "../../../utils/SubUtils";
import { getMarketplaceTopBots } from "../../../actions/marketplace-action";
import "./TopBotsLeaderboard.scss";

const TopBotsLeaderboard = (props) => {
  const { getMarketplaceTopBots } = props;
  const subscription =
    useSelector((state) => state.auth.user.user_subscription) || {};
  const ownerTemplatesTotal =
    useSelector((state) => state.marketplace.templates.my_template_count) || 0;
  const topBots =
    useSelector((state) => state.marketplace.topBotsLeaderboard) || [];
  const updatedAt = useSelector((state) => state.marketplace.topBotsUpdatedAt);
  const canAccess = isPremiumOrPro(subscription);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!canAccess) {
      return;
    }

    setIsLoading(true);
    getMarketplaceTopBots(50)
      .catch((err) => {
        toast.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [canAccess]);

  return (
    <ContentContainer url="marketplace" title="Marketplace" showChat={true}>
      <div className="main-right-content">
        <div className="marketpalce-landing-header">
          <div className="row align-items-center">
            <div className="col-sm-12">
              <div className="ml-header-left top-bots-header-links">
                <Link to="/marketplace" className="no-decoration">
                  <button className="mr-2">Marketplace</button>
                </Link>
                <Link to="/rented-strategies" className="no-decoration">
                  <button className="mr-2">My Strategies</button>
                </Link>
                {ownerTemplatesTotal > 0 && (
                  <Link to="/manage-bot" className="no-decoration">
                    <button className="mr-2">Manage</button>
                  </Link>
                )}
                <Link to="/marketplace/top-50" className="no-decoration">
                  <button className="mr-2 active">Top 50</button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="top-bots-page">
          <div className="top-bots-intro-card">
            <h2>Top 50 Performing Trading Bots</h2>
            <p>
              This leaderboard showcases the top 50 performing trading bots based on
              historical performance. It is provided for informational purposes only
              and should not be considered a recommendation to buy, sell, or hold
              any security. Performance data is updated weekly.
            </p>
            <p className="top-bots-risk-copy">
              Past performance is not a reliable indicator of future results. All
              investing and trading involve risk, including the potential loss of
              your entire investment. Only invest or trade with funds you can afford
              to lose. Before making any investment or trading decisions, you should
              seek independent financial advice from a qualified financial
              professional to ensure that any strategy is appropriate for your
              individual financial circumstances and objectives.{" "}
              <a
                href="https://blog.stockhero.ai/introducing-the-top-50-performing-stock-trading-bots-leaderboard/"
                target="_blank"
                rel="noopener noreferrer"
                className="top-bots-more-link"
              >
                More details &gt;&gt;
              </a>
            </p>
          </div>

          {!canAccess ? (
            <div className="top-bots-locked-card">
              <LockedFeature
                title="Leaderboard Locked"
                description={
                  <span>
                    Upgrade to <strong>Premium, Professional, or Master</strong> to
                    view the Top 50 Performing Trading Bots leaderboard.
                  </span>
                }
                shadow={false}
              />
            </div>
          ) : (
            <div className="top-bots-table-card">
              <div className="top-bots-table-header">
                <div>
                  <h3>Leaderboard</h3>
                  <span>Updated weekly</span>
                </div>
                {updatedAt ? (
                  <p className="top-bots-updated-at">Last updated: {updatedAt}</p>
                ) : null}
              </div>

              {isLoading ? (
                <div className="top-bots-loading-state">Loading leaderboard...</div>
              ) : (
                <div className="table-responsive">
                  <table className="table top-bots-table mb-0">
                    <thead>
                      <tr>
                        <th>Rank</th>
                        <th>Strategy</th>
                        <th>Stock</th>
                        <th>Avg Trades / Month</th>
                        <th>W/L Ratio</th>
                      </tr>
                    </thead>
                    <tbody>
                      {topBots.length > 0 ? (
                        topBots.map((bot) => (
                          <tr key={`${bot.template_id}-${bot.rank}`}>
                            <td>{bot.rank}</td>
                            <td>
                              <Link
                                to={`/marketplace-detail/${bot.template_id}`}
                                className="no-decoration top-bots-strategy-link"
                              >
                                {bot.strategy}
                              </Link>
                            </td>
                            <td>{bot.stock}</td>
                            <td>
                              {bot.avg_trades_per_month != null
                                ? Math.ceil(Number(bot.avg_trades_per_month))
                                : "-"}
                            </td>
                            <td>{bot.wl_ratio}%</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center py-4">
                            No leaderboard data available.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </ContentContainer>
  );
};

export default connect(null, { getMarketplaceTopBots })(TopBotsLeaderboard);
